import { render, staticRenderFns } from "./viewpagerManage.vue?vue&type=template&id=39f6e2ea&"
import script from "./viewpagerManage.vue?vue&type=script&lang=js&"
export * from "./viewpagerManage.vue?vue&type=script&lang=js&"
import style0 from "./viewpagerManage.vue?vue&type=style&index=0&id=39f6e2ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports